import type { CybusServer } from '../../../domain'

import { mapResourceNames, mapToStatusType, type ServerProxyParams } from '..'

export const mapCybusServer = ({ id, protocol, currentState }: ServerProxyParams): CybusServer => {
    const [service, name] = mapResourceNames(id)
    return { id, service, name, status: mapToStatusType(currentState), protocol }
}
